import React from 'react';

import { HEIGHT_ITEM, HEIGHT_ONE_PERCENT, propsArrowLineBackground } from '../const';
import { IGantGridArrowRaw } from './gantGridArrowSS';

const MIN_DISTANCE_ARROW = 10;

const GantGridArrowES: React.FC<IGantGridArrowRaw> = ({ pointStart, pointEnd, propsArrowLine }) => {
    const maxX = Math.max(pointStart.x, pointEnd.x) - MIN_DISTANCE_ARROW;
    const diff = Math.abs(pointStart.x - pointEnd.x) < 20 ? 3 : Math.abs(pointStart.x - pointEnd.x);

    const deltaY = pointStart.y < pointEnd.y ? 0 : HEIGHT_ITEM;

    const renderLine = (propsLine: React.SVGLineElementAttributes<SVGLineElement>) => (
        <>
            {pointStart.x < pointEnd.x && diff >= MIN_DISTANCE_ARROW * 2 ? (
                <>
                    <line x1={pointStart.x} y1={pointStart.y} x2={maxX} y2={pointStart.y} {...propsLine} />
                    <line x1={maxX} y1={pointStart.y} x2={maxX} y2={pointEnd.y} {...propsLine} />
                    <line x1={maxX} y1={pointEnd.y} x2={pointEnd.x} y2={pointEnd.y} {...propsLine} />
                </>
            ) : (
                <>
                    <line
                        x1={pointStart.x}
                        y1={pointStart.y}
                        x2={pointStart.x + MIN_DISTANCE_ARROW}
                        y2={pointStart.y}
                        {...propsLine}
                    />

                    <line
                        x1={pointStart.x + MIN_DISTANCE_ARROW}
                        y1={pointStart.y}
                        x2={pointStart.x + MIN_DISTANCE_ARROW}
                        y2={pointEnd.y - HEIGHT_ONE_PERCENT * 50 + deltaY}
                        {...propsLine}
                    />
                    <line
                        x1={pointStart.x + MIN_DISTANCE_ARROW}
                        y1={pointEnd.y - HEIGHT_ONE_PERCENT * 50 + deltaY}
                        x2={pointStart.x - diff - MIN_DISTANCE_ARROW}
                        y2={pointEnd.y - HEIGHT_ONE_PERCENT * 50 + deltaY}
                        {...propsLine}
                    />
                    <line
                        x1={pointStart.x - diff - MIN_DISTANCE_ARROW}
                        y1={pointEnd.y - HEIGHT_ONE_PERCENT * 50 + deltaY}
                        x2={pointStart.x - diff - MIN_DISTANCE_ARROW}
                        y2={pointEnd.y}
                        {...propsLine}
                    />
                    <line
                        x1={pointStart.x - diff - MIN_DISTANCE_ARROW}
                        y1={pointEnd.y}
                        x2={pointEnd.x}
                        y2={pointEnd.y}
                        {...propsLine}
                    />
                </>
            )}
        </>
    );

    return (
        <>
            {renderLine(propsArrowLine)}
            {renderLine(propsArrowLineBackground)}
        </>
    );
};

export default React.memo(GantGridArrowES);
